import React, {
  createContext,
  useEffect,
  useRef,
  useState
} from 'react';
import _ from 'lodash';
import { THEMES, GLOB } from 'src/constants';
import i18n from 'src/i18n';
import * as dataSetting from 'src/dataservice/dataSetting';
import { normalizeLanguage, parseSettings, readStoredSettings } from 'src/utils/language';

const defaultSettings = {
  direction: 'ltr',
  responsiveFontSizes: true,
  theme: THEMES.TEROTECH,
  language: 'en',
  globalization: GLOB.en
};

export const restoreSettings = readStoredSettings;

export const storeSettings = (settings) => {

  try {
    window.localStorage.setItem('settings', JSON.stringify(settings));
    window.localStorage.setItem('i18nextLng', settings.language);
  } catch (err) {
    console.error(err);
  }
};

const SettingsContext = createContext({

  settings: defaultSettings,
  saveSettings: () => { },
  initializeSettings: () => Promise.resolve()
});

export const SettingsProvider = ({ settings, children }) => {
  const [currentSettings, setCurrentSettings] = useState(() => {
    const restored = settings || restoreSettings();
    return {
      ...defaultSettings,
      ...restored,
      language: normalizeLanguage(restored && restored.language) || i18n.language
    };
  });
  const settingsRef = useRef(currentSettings);
  
  const handleSaveSettings = (update = {}) => {
    
    const mergedSettings = _.merge({}, settingsRef.current, update);
    mergedSettings.language = normalizeLanguage(mergedSettings.language) || 'en';
    const languageChanged = i18n.changeLanguage(mergedSettings.language);
    settingsRef.current = mergedSettings;

    setCurrentSettings(mergedSettings);
    storeSettings(mergedSettings);
    return languageChanged;
    
  };

  const initializeSettings = async plantLanguage => {
    let restored = restoreSettings();
    // Auth waits so menus and table columns mount in the correct language.
    if (!restored || !normalizeLanguage(restored.language)) {
      try {
        const response = await dataSetting.get();
        restored = { ...restored, ...parseSettings(response.data) };
      } catch (err) {
        console.error(err);
      }
    }

    return handleSaveSettings({
      ...restored,
      language: normalizeLanguage(restored && restored.language)
        || normalizeLanguage(plantLanguage)
        || 'en'
    });
  };

  useEffect(() => {
    document.dir = currentSettings.direction;
  }, [currentSettings.direction]);

  return (
    <SettingsContext.Provider
      value={{
        settings: currentSettings,
        saveSettings: handleSaveSettings,
        initializeSettings
      }}
    >
      {children}
    </SettingsContext.Provider>
  );
};

export const SettingsConsumer = SettingsContext.Consumer;

export default SettingsContext;
